var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "cookies-modal",
      attrs: { "background-mode": "", visible: _vm.isShown },
      on: {
        "on-close": function($event) {
          _vm.isShown = false
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "cookies-modal__content" },
        [
          _c("div", { staticClass: "cookies-modal__text" }, [
            _vm._v(
              "\n      Мы используем файлы cookie и другие технологии для анализа использования наших товаров и\n      услуг и повышения качества рекомендаций.\n      Нажимая на кнопку «Да, согласен», вы даете согласие на обработку своих персональных данных в\n      соответствии с "
            ),
            _c("a", { attrs: { target: "_blank", href: "/agreement" } }, [
              _vm._v("пользовательским соглашением.")
            ])
          ]),
          _c("ui-button", {
            staticClass: "cookies-modal__button",
            attrs: { text: "Да, согласен" },
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.setCookie($event)
              }
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }